<template>
  <div class="chat-widget" @keydown.escape="open = false">
    <div class="chat-toggle" @click="toggleOpen">
      <div class="chat-toggle__icon">
        <feather-icon icon="MessageCircleIcon" size="20" />
      </div>
      <div class="chat-toggle__text">
        <strong>Nina</strong>
        <span>¿Necesitas ayuda?</span>
      </div>
    </div>

    <transition name="chat-fade">
      <div v-if="open" class="chat-panel" @click.stop>
        <div class="chat-header">
          <div class="chat-avatar">
            <div class="chat-avatar__inner">
              K
            </div>
          </div>
          <div>
            <h6>Asistente Nina</h6>
            <p>Estoy aquí para ayudarte.</p>
          </div>
          <button
            class="chat-close"
            aria-label="Cerrar chat"
            @click="toggleOpen"
          >
            ×
          </button>
        </div>

        <div ref="scrollContainer" class="chat-messages">
          <div
            v-for="(message, index) in messages"
            :key="index"
            :class="['chat-bubble', message.from]"
          >
            <!-- CAMBIO AQUÍ: Usamos un div con v-html y una función formateadora -->
            <div
              class="texto-mensaje"
              v-html="formatearTexto(message.text)"
            ></div>

            <div v-if="message.video" class="tarjeta-video">
              <div class="video-content">
                <div class="video-icon">🎬</div>
                <div class="video-info">
                  <div class="video-label">Tutorial de Ayuda</div>
                  <div class="video-title">{{ message.video.titulo }}</div>
                </div>
              </div>
              <a :href="message.video.url" target="_blank" class="btn-video">
                <span>▶</span> Ver Video
              </a>
            </div>
            <small>{{ message.time }}</small>
          </div>
          <!-- <div
            v-for="(message, index) in messages"
            :key="index"
            :class="['chat-bubble', message.from]"
          >
            <p>{{ message.text }}</p>
            <div v-if="message.video" class="tarjeta-video">
              <div class="video-content">
                <div class="video-icon">🎬</div>
                <div class="video-info">
                  <div class="video-label">Tutorial de Ayuda</div>
                  <div class="video-title">{{ message.video.titulo }}</div>
                </div>
              </div>
              <a :href="message.video.url" target="_blank" class="btn-video">
                <span>▶</span> Ver Video
              </a>
            </div>
            <small>{{ message.time }}</small>
          </div> -->
        </div>

        <div class="chat-input">
          <input
            v-model="draft"
            placeholder="Escribe tu mensaje"
            aria-label="Mensaje de chat"
            @keyup.enter="sendMessage"
            :disabled="loading"
          />
          <button class="btn-send" @click="sendMessage" :disabled="loading">
            {{ loading ? 'Enviando...' : 'Enviar' }}
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import apiCall from '@/utils/apiCall'

export default {
  name: 'ChatWidget',
  data() {
    return {
      open: false,
      draft: '',
      loading: false,
      messages: [
        {
          from: 'bot',
          text: '¡Hola! Soy Nina, tu asistente. ¿En qué puedo ayudarte hoy?',
          time: 'Ahora',
        },
      ],
    }
  },
  methods: {
    toggleOpen() {
      this.open = !this.open
      if (this.open) {
        this.$nextTick(this.scrollToBottom)
      }
    },
    formatearTexto(texto) {
      if (!texto) return ''
      // Reemplaza los saltos de línea \n por <br> y las negritas básicas si las hubiera
      return texto
        .replace(/\n/g, '<br>')
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Opcional: convierte **texto** en negritas reales
    },
    async sendMessage() {
      const text = this.draft.trim()
      if (!text || this.loading) return

      this.messages.push({
        from: 'user',
        text,
        time: 'Ahora',
      })
      this.draft = ''
      this.loading = true
      this.$nextTick(this.scrollToBottom)

      const { postApiJson } = apiCall()
      const typingIndex = this.messages.length
      this.messages.push({
        from: 'bot',
        text: 'Escribiendo...',
        time: '',
      })
      this.$nextTick(this.scrollToBottom)

      let botResponse = 'No se pudo conectar con el chat. Intenta nuevamente.'
      try {
        // --- AQUÍ ESTÁ EL CAMBIO CLAVE ---
        // Construimos el historial mapeando los mensajes previos que ya están en pantalla
        const historialFormateado = this.messages
          .slice(0, typingIndex - 1) // Excluimos el "Escribiendo..." y el mensaje actual recién agregado
          .map(m => ({
            role: m.from === 'user' ? 'user' : 'assistant',
            content: m.text,
          }))

        const payload = {
          mensaje: text,
          historial: historialFormateado, // <--- Mandamos el historial al backend
        }

        const resp = await postApiJson(
          'https://ingeniandows.com/',
          'apininachat',
          payload,
        )
        if (resp) {
          botResponse = resp
          console.log('Chat API response:', botResponse)
        }
      } catch (error) {
        console.error('Chat API error:', error)
      }

      this.messages.splice(typingIndex, 1, {
        from: 'bot',
        text: botResponse.respuesta,
        video: botResponse.video || null,
        time: 'Ahora',
      })
      this.loading = false
      this.$nextTick(this.scrollToBottom)
    },
    scrollToBottom() {
      const container = this.$refs.scrollContainer
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },
  },
}
</script>

<style scoped>
.chat-widget {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.75rem;
}

.chat-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.85rem 1rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #5c6ac4 0%, #7f94ff 100%);
  color: white;
  box-shadow: 0 16px 40px rgba(44, 61, 130, 0.22);
  cursor: pointer;
  min-width: 180px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.chat-toggle:hover {
  transform: translateY(-2px);
}

.chat-toggle__icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.18);
}

.chat-toggle__text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.chat-toggle__text strong {
  font-size: 0.95rem;
}

.chat-toggle__text span {
  font-size: 0.78rem;
  opacity: 0.9;
}

.chat-panel {
  width: min(360px, calc(100vw - 40px));
  max-height: 520px;
  background: white;
  border-radius: 28px;
  box-shadow: 0 28px 80px rgba(41, 75, 171, 0.18);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.chat-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1rem 0.9rem;
  background: #f5f7ff;
}

.chat-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5c6ac4 0%, #7f94ff 100%);
  display: grid;
  place-items: center;
  color: white;
  font-weight: 700;
  flex-shrink: 0;
}

.chat-header h6 {
  margin: 0;
  font-size: 0.95rem;
}

.chat-header p {
  margin: 0.2rem 0 0;
  font-size: 0.78rem;
  color: #677294;
}

.chat-close {
  border: none;
  background: transparent;
  font-size: 1.35rem;
  line-height: 1;
  color: #8a96b3;
  margin-left: auto;
  cursor: pointer;
}

.chat-messages {
  padding: 1rem;
  background: #f7f8ff;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.chat-bubble {
  position: relative;
  max-width: 85%;
  padding: 0.95rem 1rem;
  border-radius: 20px;
  box-shadow: 0 12px 30px rgba(79, 91, 168, 0.08);
}

.chat-bubble.bot {
  align-self: flex-start;
  background: white;
  color: #1b243d;
  border-radius: 20px 20px 20px 4px;
}

.chat-bubble.bot::after {
  content: '';
  position: absolute;
  left: -6px;
  bottom: 12px;
  width: 14px;
  height: 14px;
  background: white;
  transform: rotate(45deg);
  border-radius: 2px;
  box-shadow: -2px 2px 4px rgba(79, 91, 168, 0.08);
}

.chat-bubble.user {
  align-self: flex-end;
  background: linear-gradient(135deg, #5c6ac4 0%, #7f94ff 100%);
  color: white;
  border-radius: 20px 20px 4px 20px;
}

.chat-bubble.user::after {
  content: '';
  position: absolute;
  right: -6px;
  bottom: 12px;
  width: 14px;
  height: 14px;
  background: linear-gradient(135deg, #5c6ac4 0%, #7f94ff 100%);
  transform: rotate(45deg);
  border-radius: 2px;
}

.chat-bubble p {
  margin: 0;
  line-height: 1.55;
}

.chat-bubble small {
  display: block;
  margin-top: 0.5rem;
  font-size: 0.72rem;
  opacity: 0.75;
}

.tarjeta-video {
  margin-top: 0.85rem;
  padding: 0.85rem;
  background: linear-gradient(135deg, #f0f4ff 0%, #e8edff 100%);
  border-left: 4px solid #5c6ac4;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  box-shadow: inset 0 2px 8px rgba(92, 106, 196, 0.06);
  transition: all 0.3s ease;
}

.tarjeta-video:hover {
  box-shadow: inset 0 2px 8px rgba(92, 106, 196, 0.12),
    0 4px 12px rgba(92, 106, 196, 0.15);
  transform: translateX(2px);
}

.video-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  min-width: 0;
}

.video-icon {
  font-size: 1.5rem;
  min-width: 2.2rem;
  height: 2.2rem;
  display: grid;
  place-items: center;
  background: #5c6ac4;
  color: white;
  border-radius: 8px;
  flex-shrink: 0;
}

.video-info {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}

.video-label {
  font-size: 0.7rem;
  font-weight: 700;
  color: #5c6ac4;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  opacity: 0.8;
}

.video-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1b243d;
  word-break: break-word;
  line-height: 1.3;
}

.btn-video {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  background: #5c6ac4;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(92, 106, 196, 0.25);
}

.btn-video:hover {
  background: #4d5ba8;
  box-shadow: 0 6px 16px rgba(92, 106, 196, 0.35);
  transform: translateY(-2px);
}

.btn-video span {
  font-size: 0.75rem;
}

.chat-input {
  padding: 1rem;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.75rem;
  background: white;
  border-top: 1px solid #edf0ff;
}

.chat-input input {
  width: 100%;
  border: 1px solid #dfe4ff;
  border-radius: 999px;
  padding: 0.95rem 1rem;
  font-size: 0.94rem;
  color: #1b243d;
  outline: none;
}

.chat-input input:focus {
  border-color: #7f94ff;
  box-shadow: 0 0 0 4px rgba(127, 148, 255, 0.12);
}

.btn-send {
  border: none;
  border-radius: 999px;
  background: #5c6ac4;
  color: white;
  padding: 0 1.15rem;
  min-width: 86px;
  font-weight: 600;
  cursor: pointer;
}

.chat-fade-enter-active,
.chat-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.chat-fade-enter-from,
.chat-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
